import styled from "styled-components";
import { KgFlowHandleVisual } from "../../atoms/KgFlowHandle";

export const Root = styled.div`
  position: relative;
  display: inline-block;
`;

export const RightSourceHandle = styled(KgFlowHandleVisual)`
  top: 50% !important;
  right: 0 !important;
  left: auto !important;
  bottom: auto !important;
  transform: translate(50%, -50%) !important;
`;
